// material-ui
import { Box, Typography } from '@mui/material';
import React from 'react'
// project import
import NavGroup from './NavGroup';
import menuItem from '../../../../../menuItems';


// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {


    const navGroups = menuItem.items.map((item: any) => {

        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            case 'collapse':

                return <NavGroup key={item.id} item={item}  />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Fix - Navigation Group
                    </Typography>
                );
        }
    });

    return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
};

export default Navigation;
